export const getErrorMessage = (
  error: unknown,
  defaultMessage = "Произошла ошибка"
): string => {
  if (error && typeof error === "object" && "data" in error && typeof (error as any).data === "object") {
    const data = (error as any).data as Record<string, any>;

    for (const key in data) {
      const value = data[key];

      if (Array.isArray(value) && value.length > 0) {
        return value[0];
      }

      if (typeof value === "string" && value.trim() !== "") {
        return value;
      }
    }
  }
  return defaultMessage;
};
